/*jslint browser: true */
/*global window */


(function($){

// ---------------------------------------------- // 
// Scroll trigger functionality
// ---------------------------------------------- // 
// Use this function for any custom lazyloaded/interactions on scroll

   function scrollTrigger(selector, options = {}) {
      let els = document.querySelectorAll(selector)
      els = Array.from(els)
      els.forEach(el => {
        addObserver(el, options)
      })
    }
    function addObserver(el, options) {
      if(!('IntersectionObserver' in window)) {
        if(options.cb){
          options.cb(el)
        } else{
          entry.target.classList.add('active')
        }
        return
      }
      let observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if(entry.isIntersecting) {
            if(options.cb) {
              options.cb(el)
            } else{
              entry.target.classList.add('active')
               // Iframe lazyloading
              if (entry.target.classList.contains('iframe-lazyload')) {
                  // Removes commented content within a container
                  let iframeContainer = entry.target;
                  let htmlContent = iframeContainer.innerHTML;
                  htmlContent = htmlContent.replace(/<!--/g, '').replace(/-->/g, '');
                  iframeContainer.innerHTML = htmlContent;
               }   
               // CTA Panel 
              if(entry.target.classList.contains('cta-container')) {
                  $('.cta-circles .cta-circle1').addClass('cta-vibrate');
              }
               // Video lazyloading
               if (entry.target.classList.contains('video-lazyload')) {
                  let vidContainer = entry.target;
                  let videoEl = vidContainer.querySelector('video');
                  let src = videoEl.getAttribute('data-src');
                  videoEl.setAttribute('src', src);
               } 
               // Statistics Counter
               if (entry.target.classList.contains('counter-wrap')) {
                  counter();
               } 
               // Wavelength Draw
               if(entry.target.classList.contains('wavelengthDraw')) {
                  var mySVG = $('.wavelengthDraw').drawsvg({
                    duration: 3000,
                    stagger: 100,
                    easing: 'swing',
                    reverse: false
                  });
                  mySVG.drawsvg('animate');
              }
              // Red Blue Box
              if(entry.target.classList.contains('red-blue-box-start')) {
                  var startWave = $('.red-blue-box-start').drawsvg({
                      duration: 3000,
                      stagger: 100,
                      easing: 'swing',
                      reverse: false
                  });
                  startWave.drawsvg('animate');
                  // Wait until the first wave is done to start the second wave
                  setTimeout(function(){
                      $('.red-blue-box-end').removeClass('invisible');
                      var endWave = $('.red-blue-box-end').drawsvg({
                          duration: 3000,
                          stagger: 100,
                          easing: 'swing',
                          reverse: false
                      });
                      endWave.drawsvg('animate');
                  }, 3500);
              }
              // Statistics Boxes
              if (entry.target.classList.contains('stats-wrap')) {
                stat_counter();
              }
            }
            observer.unobserve(entry.target)
          }
        })
      }, options)
      observer.observe(el)
    }

scrollTrigger('.iframe-lazyload', {
   rootMargin: '500px',
});
scrollTrigger('.video-lazyload', {
   rootMargin: '500px',
});
scrollTrigger('.counter-wrap');
scrollTrigger('.stats-wrap');

scrollTrigger('.wavelengthDraw');
scrollTrigger('.red-blue-box-start');
//! *********************************
// Banner
//! ********************************

if ($('.banner-slider').length) {
   $('.banner-slider').slick({
      arrows: true,
      dots: false,
      autoplay: false,
      infinte: true,
      prevArrow: $('.banner-block .slide-arrow.prev'),
      nextArrow: $('.banner-block .slide-arrow.next'),
   });
}


//! *********************************
//! To be separated into files
//! ********************************

//! *********************************
// Statistics Counter
//! ********************************

function counter(){
    $('.counter-item').each(function (i, e) {
        let dialAmount = $(this).data('dial-amount')
        let finishPoint = (dialAmount - 2) / 100;
        let iteration = i + 1;
        let num = $(this).find('.number').text();
        let decNum = (num.toString().split('.')[1] || '').length;
        $(this).find('.number').prop('Counter',0).animate({
            Counter: $(this).find('.number').text()
        }, {
            duration: 2000,
            easing: 'swing',
            step: function (now) {
                $(this).text(parseFloat(now).toFixed(decNum));
            }
        });
        $('#stat-path-' + iteration).addClass('draw')
        gsap.to("#stat-end-" + iteration, {
            duration: 2, 
            repeat: 0,
            repeatDelay: 3,
            yoyo: false,
            ease: "none",
            motionPath:{
                path: "#stat-path-" + iteration,
                align: "#stat-path-" + iteration,
                autoRotate: true,
                alignOrigin: [0.5, 0.5],
                start: 0,
                end: finishPoint
            }
        });
        if ($(this).hasClass('ten')) {
        $(this).find('.progress').addClass('loadten');
        }
        if ($(this).hasClass('twenty')) {
        $(this).find('.progress').addClass('loadtwenty');
        }
        if ($(this).hasClass('twenty-five')) {
        $(this).find('.progress').addClass('loadtwentyfive');
        }
        if ($(this).hasClass('thirty')) {
        $(this).find('.progress').addClass('loadthirty');
        }
        if ($(this).hasClass('forty')) {
        $(this).find('.progress').addClass('loadforty');
        }
        if ($(this).hasClass('fifty')) {
        $(this).find('.progress').addClass('loadfifty');
        }
        if ($(this).hasClass('sixty')) {
        $(this).find('.progress').addClass('loadsixty');
        }
        if ($(this).hasClass('seventy')) {
        $(this).find('.progress').addClass('loadseventy');
        }
        if ($(this).hasClass('seventy-five')) {
        $(this).find('.progress').addClass('loadseventyfive');
        }
        if ($(this).hasClass('eighty')) {
        $(this).find('.progress').addClass('loadeighty');
        }
        if ($(this).hasClass('ninety')) {
        $(this).find('.progress').addClass('loadninety');
        }
        if ($(this).hasClass('one-hundred')) {
        $(this).find('.progress').addClass('loadonehundred');
        }
    });
}

// ---------------------------------------------- //
// Stats Counter
// ---------------------------------------------- //
function stat_counter(){
  $('.stats-item').each(function () {
    let num = $(this).find('.number').text();
    let decNum = (num.toString().split('.')[1] || '').length;
     $(this).find('.number').prop('Counter',0).animate({
         Counter: $(this).find('.number').text()
     }, {
         duration: 2000,
         easing: 'swing',
         step: function (now) {
            $(this).text(parseFloat(now).toFixed(decNum));
         }
     });
 });
}

// ---------------------------------------------- // 
// Responsive slick function
// ---------------------------------------------- // 


    // let winWidth = $(window).width();
   
    function detectSlick(el, options, breakpoint){
      const winWidth = $(window).width();
      if(el.length){
         if (!$(''+ el +'').hasClass('slick-initialized') && winWidth < breakpoint) {
             $(''+ el +'').slick(options);
         }
         if ($(''+ el +'').hasClass('slick-initialized') && winWidth > breakpoint) {
             $(''+ el +'').slick('unslick');
         }
      }
   }
  
   $(window).on('resize', function(){
     const winWidth = $(window).width();
     detectSlick('.feature-wrap', {arrows: false,autoplay: true,infinite: true,dots: false}, 768);
    //  detectSlick('.cta-columns-wrap', {arrows: false,autoplay: true,infinite: true,dots: false}, 525);
   });
  
   detectSlick('.feature-wrap', {arrows: false,autoplay: true,infinite: true,dots: false}, 768);
  //  detectSlick('.cta-columns-wrap', {arrows: false,autoplay: true,infinite: true,dots: false}, 525);


// ---------------------------------------------- //
// Figure lightbox
// ---------------------------------------------- //
function initFigureLightbox() {
  if (!$('figure.lightbox').length) {
    return;
  }

  if (!$('.site-lightbox').length) {
    $('body').append(
      '<div class="site-lightbox" aria-hidden="true" role="dialog" aria-modal="true">' +
        '<button type="button" class="site-lightbox__close" aria-label="Close image">&times;</button>' +
        '<img class="site-lightbox__image" src="" alt="" />' +
      '</div>'
    );
  }

  var $modal = $('.site-lightbox');
  var $modalImage = $modal.find('.site-lightbox__image');

  $('figure.lightbox').attr({
    tabindex: 0,
    role: 'button'
  });

  function openLightbox(src, altText) {
    if (!src) {
      return;
    }
    $modalImage.attr('src', src);
    $modalImage.attr('alt', altText || '');
    $modal.addClass('is-open').attr('aria-hidden', 'false');
    $('body').addClass('lightbox-open');
  }

  function closeLightbox() {
    $modal.removeClass('is-open').attr('aria-hidden', 'true');
    $('body').removeClass('lightbox-open');
    $modalImage.attr('src', '');
  }

  function getFigureImageSource(figure) {
    var img = figure.querySelector('img');
    var anchor = figure.querySelector('a[href]');
    var src = '';

    if (!img) {
      return null;
    }

    if (anchor) {
      src = anchor.getAttribute('href');
    }

    if (!src && img.dataset && img.dataset.fullUrl) {
      src = img.dataset.fullUrl;
    }

    if (!src) {
      src = img.currentSrc || img.getAttribute('src');
    }

    return {
      src: src,
      alt: img.getAttribute('alt') || ''
    };
  }

  $(document).on('click', 'figure.lightbox', function(e) {
    if ($(e.target).closest('figcaption a').length) {
      return;
    }

    e.preventDefault();
    var imageData = getFigureImageSource(this);
    if (imageData) {
      openLightbox(imageData.src, imageData.alt);
    }
  });

  $(document).on('keydown', 'figure.lightbox', function(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      var imageData = getFigureImageSource(this);
      if (imageData) {
        openLightbox(imageData.src, imageData.alt);
      }
    }
  });

  $(document).on('click', '.site-lightbox, .site-lightbox__close', function(e) {
    if ($(e.target).is('.site-lightbox, .site-lightbox__close')) {
      closeLightbox();
    }
  });

  $(document).on('keydown', function(e) {
    if (e.key === 'Escape' && $modal.hasClass('is-open')) {
      closeLightbox();
    }
  });
}

initFigureLightbox();



})(jQuery);